import {
  Button,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  TextField as MUITextField,
  Typography,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import { useAddress } from "components/request-document/components/Address";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
  StyleCheckbox,
  StyledTableCell,
  TableRowHead,
  UploadButton,
  useStyles,
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import FileService from "services/FileService";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";
import { openFileById } from "libs/utils/file";
import usePrevious from "libs/hooks/usePrevious";
const TextField = React.memo(MUITextField);

export default function CompanyInfo({ formik }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });

  const masterData = useSelector(selectMasterData);
  const isYearMonth = formik.values?.document.ContractTermTypeCompany === "Y";
  const isPeriod = formik.values?.document.ContractTermTypeCompany === "P";
  const isOther = formik.values?.document.ContractTermTypeCompany === "O";
  const jobPositionConfig = get(masterData, "jobPositionConfig", []);
  const jobTable = get(formik.values, `document.JobPositionCompany.0`, {});
  const jobSubPositionConfig =
    jobPositionConfig.find((job) => job.jobID === jobTable.jobID)
      ?.jobSubPosition || [];

  const index = 0;
  const prevJobPosition = usePrevious(formik.values.JobPosition);
  const isJobPositionChange =
    prevJobPosition && prevJobPosition !== formik.values.JobPosition;
  useEffect(() => {
    if (isJobPositionChange) {
      formik.setFieldValue("JobSubPosition", "");
    }
  }, [formik, isJobPositionChange]);
  const typeOfbusinessindustryConfig = get(
    masterData,
    "typeOfbusinessindustryConfig",
    []
  );
  // console.log(typeOfbusinessindustryConfig);

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div
              className={classes.flexRow}
              style={{ flex: 1, display: "flex" }}
            >
              <InputLabel>Job position</InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job position</InputLabel>
                <Select
                  disabled={!canEdit}
                  label="Select Job position"
                  name={`document.JobPositionCompany.${index}.jobID`}
                  defaultValue=""
                  // value={get(
                  //   formik.values,
                  //   `document.JobTable.${index}.jobID`,
                  //   ""
                  // )}
                  value={formik.values.document.JobPositionCompany[0].jobID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobPositionConfig.map((jobPosition) => (
                    <MenuItem key={jobPosition.jobID} value={jobPosition.jobID}>
                      {jobPosition.jobName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job Sub position</InputLabel>

                <Select
                  disabled={!canEdit}
                  label="Select Job Sub position"
                  name={`document.JobPositionCompany.${index}.jobsubID`}
                  value={formik.values.document.JobPositionCompany[0].jobsubID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobSubPositionConfig.map((jobPosition) => (
                    <MenuItem
                      key={jobPosition.jobsubID}
                      value={jobPosition.jobsubID}
                    >
                      {jobPosition.jobsubName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel style={{ width: 90 }}>Job Title</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.JobPositionCompany.${index}.jobTitle`}
                value={get(
                  formik.values,
                  `document.JobPositionCompany.${index}.jobTitle`,
                  ""
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  `document.JobPositionCompany.${index}.jobTitle`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.JobPositionCompany.${index}.jobTitle`,
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Job description</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.JobPositionCompany.${index}.jobDesc`}
                value={get(
                  formik.values,
                  `document.JobPositionCompany.${index}.jobDesc`,
                  ""
                )}
                error={isError(
                  `document.JobPositionCompany.${index}.jobDesc`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.JobPositionCompany.${index}.jobDesc`,
                  formik
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                multiline
                rows={5}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={6}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel> Contract term</InputLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Year"
                      checked={isYearMonth}
                      onChange={() =>
                        formik.setFieldValue(
                          "document.ContractTermTypeCompany",
                          "Y"
                        )
                      }
                    />
                  }
                  label="Year - Months"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Period (dd-mm-yyyy to dd-mm-yyyy)"
                      checked={isPeriod}
                      onChange={() =>
                        formik.setFieldValue(
                          "document.ContractTermTypeCompany",
                          "P"
                        )
                      }
                    />
                  }
                  label="Period"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Other"
                      checked={isOther}
                      onChange={() =>
                        formik.setFieldValue(
                          "document.ContractTermTypeCompany",
                          "O"
                        )
                      }
                    />
                  }
                  label="Other ( Please specify )"
                />
              </FormGroup>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                }}
              >
                {isYearMonth && (
                  <>
                    <TextField
                      disabled={!canEdit}
                      className={classes.formControl}
                      variant="outlined"
                      placeholder="Year"
                      // type="number"
                      onKeyDown={(e) => {
                        const pattern = /[^0-9]/g;
                        const isNotAllow =
                          e.key.length === 1 && pattern.test(e.key);

                        if (isNotAllow) {
                          e.preventDefault();
                        }
                      }}
                      name="document.ContractYearCompany"
                      value={formik.values?.document.ContractYearCompany}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError("document.ContractYearCompany", formik)}
                      helperText={getErrorMessage(
                        "document.ContractYearCompany",
                        formik
                      )}
                    />
                    <TextField
                      disabled={!canEdit}
                      className={classes.formControl}
                      variant="outlined"
                      placeholder="Month"
                      // type="number"
                      onKeyDown={(e) => {
                        const pattern = /[^0-9]/g;
                        const isNotAllow =
                          e.key.length === 1 && pattern.test(e.key);

                        if (isNotAllow) {
                          e.preventDefault();
                        }
                      }}
                      name="document.ContractMonthsCompany"
                      value={formik.values?.document.ContractMonthsCompany}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError("document.ContractMonthsCompany", formik)}
                      helperText={getErrorMessage(
                        "document.ContractMonthsCompany",
                        formik
                      )}
                    />
                  </>
                )}
                {isPeriod && (
                  <>
                    <DatePicker
                      disabled={!canEdit}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Start date"
                      views={["year", "month", "date"]}
                      name="document.ContractPeriodFromCompany"
                      maxDate={
                        formik.values?.document.ContractPeriodFromCompany
                          ? formik.values?.document.ContractPeriodFromCompany
                          : undefined
                      }
                      value={
                        formik.values?.document.ContractPeriodFromCompany ||
                        null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          "document.ContractPeriodFromCompany",
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(
                        "document.ContractPeriodFromCompany",
                        formik
                      )}
                      helperText={getErrorMessage(
                        "document.ContractPeriodFromCompany",
                        formik
                      )}
                    />
                    <DatePicker
                      disabled={!canEdit}
                      className={classes.formControl}
                      inputVariant="outlined"
                      // disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="End date"
                      views={["year", "month", "date"]}
                      name="document.ContractPeriodToCompany"
                      minDate={
                        formik.values?.document.ContractPeriodToCompany
                          ? formik.values?.document.ContractPeriodToCompany
                          : undefined
                      }
                      value={
                        formik.values?.document.ContractPeriodToCompany || null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          "document.ContractPeriodToCompany",
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(
                        "document.ContractPeriodToCompany",
                        formik
                      )}
                      helperText={getErrorMessage(
                        "document.ContractPeriodToCompany",
                        formik
                      )}
                    />
                  </>
                )}
                {isOther && (
                  <TextField
                    disabled={!canEdit}
                    className={classes.formControl}
                    variant="outlined"
                    placeholder="Please specify"
                    name="document.ContractOtherCompany"
                    value={formik.values?.document.ContractOtherCompany}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("document.ContractOtherCompany", formik)}
                    helperText={getErrorMessage(
                      "document.ContractOtherCompany",
                      formik
                    )}
                  />
                )}
              </div>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Average income per month* (Baht)</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanyAverIncomemonth"
                value={formik.values.document.CompanyAverIncomemonth}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanyAverIncomemonth", formik)}
                helperText={getErrorMessage(
                  "document.CompanyAverIncomemonth",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Salary (Baht per month)</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanysSalary"
                value={formik.values.document.CompanysSalary}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanysSalary", formik)}
                helperText={getErrorMessage("document.CompanysSalary", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography style={{ color: "gray" }}>
                Other items of income (Please specify)
              </Typography>
            </div>
          </div>
          <TextField
            disabled={!canEdit}
            variant="outlined"
            className={classes.textField}
            name="document.CompanyIncomeOther"
            value={formik.values.document.CompanyIncomeOther}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={isError("document.CompanyIncomeOther", formik)}
            helperText={getErrorMessage("document.CompanyIncomeOther", formik)}
          />
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>A reference person’s name </InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanyReferencePersonName"
                value={formik.values.document.CompanyReferencePersonName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanyReferencePersonName", formik)}
                helperText={getErrorMessage(
                  "document.CompanyReferencePersonName",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>A reference person’s job title </InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanyReferenceJobTitle"
                value={formik.values.document.CompanyReferenceJobTitle}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanyReferenceJobTitle", formik)}
                helperText={getErrorMessage(
                  "document.CompanyReferenceJobTitle",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>E-mail address </InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanyEmail"
                value={formik.values.document.CompanyEmail}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanyEmail", formik)}
                helperText={getErrorMessage("document.CompanyEmail", formik)}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Mobile phone number</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanyPhoneNumber"
                value={formik.values.document.CompanyPhoneNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanyPhoneNumber", formik)}
                helperText={getErrorMessage(
                  "document.CompanyPhoneNumber",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Company name </InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanyName"
                value={formik.values.document.CompanyName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanyName", formik)}
                helperText={getErrorMessage("document.CompanyName", formik)}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Registered number </InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanyRegisterednumber"
                value={formik.values.document.CompanyRegisterednumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanyRegisterednumber", formik)}
                helperText={getErrorMessage(
                  "document.CompanyRegisterednumber",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Address</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanyAddress"
                value={formik.values.document.CompanyAddress}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanyAddress", formik)}
                helperText={getErrorMessage("document.CompanyAddress", formik)}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Office number</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanyOfficeNumber"
                value={formik.values.document.CompanyOfficeNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanyOfficeNumber", formik)}
                helperText={getErrorMessage(
                  "document.CompanyOfficeNumber",
                  formik
                )}
              />
            </div>
          </div>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Company website or e-mail address</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanyWebsite"
                value={formik.values.document.CompanyWebsite}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanyWebsite", formik)}
                helperText={getErrorMessage("document.CompanyWebsite", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div style={{ display: "flex" }}>
            <div style={{ width: "50%" }}>
              <div className={classes.wrapField}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Type of business industry
                </InputLabel>
                <FormControl fullWidth style={{ marginTop: 10 }}>
                  <InputLabel>Selected Type of business industry </InputLabel>
                  <Select
                    disabled={!canEdit}
                    label="Selected Type of business industry  "
                    name={`document.typeOfbusinessindustryID`}
                    value={formik.values.document.typeOfbusinessindustryID}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    variant="outlined"
                  >
                    {typeOfbusinessindustryConfig.map((x) => (
                      <MenuItem
                        key={x.typeOfbusinessindustryID}
                        value={x.typeOfbusinessindustryID}
                      >
                        {x.typeOfbusinessindustryName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div style={{ width: "50%", marginLeft: 5 }}>
              <div className={classes.wrapField}>
                <InputLabel style={{ fontWeight: "bold" }}>&nbsp;</InputLabel>
                <FormControl fullWidth style={{ marginTop: 10 }}>
                  <InputLabel>Selected Type of business industry </InputLabel>
                  <Select
                    disabled={!canEdit}
                    label="Selected Type of business industry  "
                    name={`document.typeOfbusinessindustrySupID`}
                    value={formik.values.document.typeOfbusinessindustrySupID}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    variant="outlined"
                  >
                    {typeOfbusinessindustryConfig.map((x) => (
                      <MenuItem
                        key={x.typeOfbusinessindustryID}
                        value={x.typeOfbusinessindustryID}
                      >
                        {x.typeOfbusinessindustryName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div style={{ width: "50%" }}>
            <div className={classes.wrapField}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Business or products or services description
              </InputLabel>
              <TextField
                name={`document.CompanyBusinessdescription`}
                value={formik.values.document.CompanyBusinessdescription}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                variant="outlined"
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow style={{ backgroundColor: "#F7FAFC" }}>
        <StyledTableCell colSpan={7}>
          <Typography className={classes.tableTitle}>
            Manufacturing/Service Process Please provide a process diagram that
            explains the manufacturing/service process (additional documents can
            be attached).
          </Typography>
        </StyledTableCell>
      </TableRow>
      <TableRowHead>
        <StyledTableCell colSpan={4} align="center">
          <InputLabel>Process Diagram</InputLabel>
        </StyledTableCell>
        <StyledTableCell align="center">
          <InputLabel>Explanation</InputLabel>
        </StyledTableCell>
      </TableRowHead>
      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.flexRow}>
            <InputLabel>File Upload ( PDF, JPG )</InputLabel>
            <div style={{ width: 18 }} />
            <UploadButton
              disabled={!canEdit}
              title={
                get(formik.values, `document.ProcessDiagramFile.FileID`, "")
                  ? "Edit"
                  : "+ Add"
              }
              id={`upload-ProcessDiagram`}
              onChange={async (event) => {
                try {
                  const response = await FileService.uploadFile({
                    file: event.target.files[0],
                    Status: true,
                  });
                  const fileId = response.results?.fileID;
                  const [filename, ext] = event.target.files[0].name.split(".");

                  formik.setFieldValue(`document.ProcessDiagramFile`, {
                    processfileID: fileId,
                    FileID: fileId,
                    filename,
                    ext,
                    Status: true,
                  });
                } catch (error) {
                  console.log("Upload error", error);
                }
              }}
            />
            {get(formik.values, `document.ProcessDiagramFile.FileID`, "") && (
              <IconButton
                style={{ width: 40 }}
                size="small"
                onClick={async () => {
                  const processfileID = get(
                    formik.values,
                    `document.ProcessDiagramFile.FileID`,
                    ""
                  );

                  openFileById(processfileID);
                }}
              >
                <VisibilityIcon />
              </IconButton>
            )}
          </div>
        </StyledTableCell>
        <StyledTableCell>
          <TextField
            disabled={!canEdit}
            variant="outlined"
            className={classes.textField}
            name="document.Explantion"
            value={formik.values.document.Explantion}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={isError("document.Explantion", formik)}
            helperText={getErrorMessage("document.Explantion", formik)}
            multiline
            rows={10}
          />
        </StyledTableCell>
      </TableRow>
    </>
  );
}
